import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-16 sm:py-24 px-4 bg-hyrox-surface relative" data-id="element-159">
      <div className="max-w-3xl mx-auto" data-id="element-160">
        <FadeIn data-id="element-161">
          <div className="prose prose-invert prose-lg sm:prose-xl max-w-none" data-id="element-162">
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-163">
              Hay algo que ningún coach de HYROX dice en voz alta pero que casi
              todos sienten.
            </p>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-164">
              No es que no saben entrenar.
            </p>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-165">
              No es que no les apasiona el deporte.
            </p>
            <p className="text-gray-300 leading-relaxed mb-8" data-id="element-166">
              Es algo más incómodo que eso.
            </p>

            <div className="bg-hyrox-dark border-l-4 border-hyrox-orange p-6 sm:p-8 rounded-r-xl mb-10 shadow-lg" data-id="element-167">
              <p className="text-white font-medium leading-relaxed mb-4" data-id="element-168">
                Es la sensación de que después de años dando clases, de
                certificaciones, de horas en pista y alumnos que mejoran de
                verdad, todavía llegás al lunes con la misma pregunta de
                siempre:
              </p>
              <p className="text-2xl sm:text-3xl font-display font-bold text-hyrox-orange mt-6" data-id="element-169">
                ¿Qué hago hoy con mis alumnos?
              </p>
            </div>

            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-170">
              Y ahí empieza el ciclo de siempre. Abrís YouTube. Revisás grupos
              de WhatsApp de coaches. Copiás una sesión que viste en Instagram.
              Armás algo que "más o menos sirve". Y el tiempo que debería ser
              tuyo se convierte en otra jornada de trabajo no pago que nadie ve
              y que nadie valora.
            </p>

            <p className="text-gray-300 leading-relaxed font-bold mb-12" data-id="element-171">
              Incluyendo vos.
            </p>

            <div className="text-center mb-12" data-id="element-172">
              <h2 className="text-3xl sm:text-4xl font-display font-bold text-white mb-4" data-id="element-173">
                El problema no es tu nivel técnico.
                <br className="hidden sm:block" data-id="element-174" />
                <span className="text-hyrox-orange" data-id="element-175">
                  Es que nadie te dio el sistema.
                </span>
              </h2>
              <p className="text-gray-400 mb-6" data-id="element-176">
                Te formaste para entrenar atletas. No para ser:
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-12" data-id="element-177">
              {['Planificador de temporadas', 'Diseñador de sesiones', 'Evaluador de rendimiento', 'Corrector de técnica', 'Estratega de competencia', 'Gestor de negocio fitness'].map((role, i) => <div key={i} className="bg-hyrox-dark border border-hyrox-muted p-4 rounded-lg text-center flex items-center justify-center" data-id="element-178">
                  <span className="font-medium text-gray-200" data-id="element-179">{role}</span>
                </div>)}
            </div>

            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-180">
              Pero eso es exactamente lo que te pide la realidad de ser coach de
              HYROX hoy.
            </p>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-181">
              Y sin un sistema que sostenga todo eso, el resultado es siempre el
              mismo:{' '}
              <strong className="text-white" data-id="element-182">
                improvisación crónica, alumnos que no ven su progreso y la
                sensación permanente de que trabajás mucho más de lo que ganás.
              </strong>
            </p>
            <p className="text-gray-300 leading-relaxed" data-id="element-183">
              No es debilidad. No es falta de pasión. Es que estás haciendo el
              trabajo de seis roles distintos sin las herramientas para ninguno
              de los seis.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}